import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import { colors } from "common";
import LazyImage from "components/LazyImage";
import { useIsMobile } from "hooks";
import { FC } from "react";

type Props = {
  open?: boolean;
  closeUploadDialog?: () => void;
};

export const SaveBuildDialog: FC<Props> = ({ open, closeUploadDialog }) => {
  const isMobile = useIsMobile()
  
  return (
    <Dialog open={open}>
      <DialogContent sx={{ textAlign: "center", px: isMobile ? "4em" : "8em" }}>
        <LazyImage
          src="/assets/images/kachi_happy.png"
          width={128}
          height={128}
        />
        <DialogContentText sx={{ fontWeight: 600, fontSize: "36px" }}>
          Successful!
        </DialogContentText>
        <DialogContentText
          sx={{ fontWeight: 400, fontSize: "18px", color: "#7D879C" }}
        >
          Build saved to your account!
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
        <Button
          onClick={closeUploadDialog}
          sx={{
            width: "166px",
            color: "white",
            bgcolor: colors.secondary,
            "&:hover": {
              backgroundColor: colors.secondary,
            },
          }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};
